module.exports = {"controllers":{"error_export_download":{"title":"Download error","content":"An error occurred while downloading an export file.","confirm":"OK"},"error_export_download_not_available":{"title":"Download error","content":"File download for the given export is not available yet.","confirm":"OK"},"error_export_preparation":{"title":"Export error","content":"An error occurred while preparing the export.","confirm":"OK"}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/exports.json
// module id = 2394
// module chunks = 1